import React, {useEffect} from "react";
import {useConfigureNotebook} from "../../../../../hooks/use-notebook-config";
import useAccessLevels from "../../../../../hooks/use-access-levels";
import {useAppSelector} from "../../../../../redux";
import {Box} from "@mui/material";
import CustomerPaymentMethodsViewCreditCardsSection from "./credit-cards";
import CustomerPaymentMethodsViewGiftCardsSection from "./gift-cards";
import useBehavioralAnalyticsTool from "../../../../../hooks/use-behavioural-analytics-tool";

const CustomerPaymentMethodsView = () => {
    const defaultCustomer = useAppSelector(state => state.customerInformation);
    const {configureNotebookTags} = useConfigureNotebook('customer-payment-methods-view');
    const {configureBehavioralTool} = useBehavioralAnalyticsTool();
    const operatorAccessLevels = useAccessLevels();

    /**
     * As soon as the component is mounted:
     * - Configures the notebook tags for the view
     * - Configures the behavioral analytics tool for the view
     */
    useEffect(() => {
        if (!defaultCustomer?.code)
            return;
        configureNotebookTags((noteTags) => noteTags.customerSalesActiveCards(defaultCustomer.code));
        configureBehavioralTool((tags) => tags.customerSalesActiveCards(defaultCustomer.code));
    }, [configureBehavioralTool, configureNotebookTags, defaultCustomer.code]);

    return (
        <>
            <Box sx={{display: 'flex', flexDirection: 'column'}}>
                {
                    operatorAccessLevels.packages.sales.manageCustomerPaymentMethods &&
                    <CustomerPaymentMethodsViewCreditCardsSection
                        customer={defaultCustomer}
                    />
                }
                <Box marginBlock={4}/>
                {
                    operatorAccessLevels.packages.sales.customerGiftCards &&
                    <CustomerPaymentMethodsViewGiftCardsSection
                        customer={defaultCustomer}
                    />
                }
            </Box>
        </>
    );
}

export default CustomerPaymentMethodsView;
